module.exports = __webpack_public_path__ + "media/audio8.cd9733e5.mp3";